import React, { ReactNode, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Box, SxProps, Theme } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';


interface TabPanelProps {
    children?: React.ReactNode;
    open: boolean;
    index: number|string;
    id: string,
    keepMounted?: boolean;
    narrow?: boolean,
    sx?: SxProps<Theme>
}

export const TabPanel = ({ children, open, index, id, keepMounted, narrow, sx }: TabPanelProps) => {
    const [touched, setTouched] = useState(false);

    useEffect(() => {
        open && setTouched(true);
    }, [open]);

    return (
        <div
            role="tabpanel"
            hidden={!open}
            id={`${id}-tabpanel-${index}`}
            aria-labelledby={`${id}-tab-${index}`}
        >
            {(open || (keepMounted && touched)) && <Box sx={sx || { px: narrow ? 0 : 2, py: 2 }}>{children}</Box>}
        </div>
    )
};

export const a11yProps = (id: string, index: number | string) => {
    return {
        id: `${id}-tab-${index}`,
        'aria-controls': `${id}-tabpanel-${index}`,
    }
};

type TabPanelsProps = {
    id: string,
    active: number,
    setSwiper: (s: any) => void,
    setIndex: (idx: number, fromSwiper: boolean) => void,
    tabs: ReactNode[],
    keepMounted?: boolean,
    narrow?: boolean,
}

export const TabPanels = ({ active, id, setIndex, setSwiper, tabs, keepMounted, narrow }: TabPanelsProps) => {
    const children = tabs.map((component, index) => (
        <SwiperSlide key={index}>
            <TabPanel
                open={active === index}
                keepMounted={keepMounted}
                index={index}
                id={id}
                narrow={narrow}
            >
                {component}
            </TabPanel>
        </SwiperSlide>
    ));

    if (isMobile) {
        return (
            <Swiper
                onSwiper={swiper => setSwiper(swiper)}
                onSlideChange={swiper => setIndex(swiper.activeIndex, true)}
            >
                {children}
            </Swiper>
        )
    }

    return (
        <div>
            {children}
        </div>
    )
};
